import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER } from '../../constant/Constant';
import NullCheckUtil from '../../util/NullCheckUtil';
import { request } from '../ApiModule';

const BASE = 'notice-popup';
const HANDLE_NOTICE_POPUP_OPEN = BASE + PATH_DELIMITER + 'HANDLE_NOTICE_POPUP_OPEN';
const HANDLE_NOTICE_POPUP_CLOSE = BASE + PATH_DELIMITER + 'HANDLE_NOTICE_POPUP_CLOSE';
const LOAD_NOTICE_POPUP_DATA = BASE + PATH_DELIMITER + 'LOAD_NOTICE_POPUP_DATA';
const HANDLE_NOTICE_POPUP_DATA = BASE + PATH_DELIMITER + 'HANDLE_NOTICE_POPUP_DATA';

export const handleNoticePopupShow = createAction(HANDLE_NOTICE_POPUP_OPEN);
export const handleNoticePopupClose = createAction(HANDLE_NOTICE_POPUP_CLOSE);
export const loadNoticePopupData = createAction(LOAD_NOTICE_POPUP_DATA);

export function* noticePopupSagas() {
    yield takeEvery(LOAD_NOTICE_POPUP_DATA, loadNoticePopupDataSaga);
}

function* loadNoticePopupDataSaga({ payload: { callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/board/notices/popups',
    });

    if (NullCheckUtil.isNotNull(result)) {
        yield put({ type: HANDLE_NOTICE_POPUP_DATA, payload: result });
        callback && callback(result.length);
    }
}

const initialState = {
    open: false,
    popups: [],
};

const module = handleActions(
    {
        [HANDLE_NOTICE_POPUP_OPEN]: (state) => ({ ...state, open: true }),
        [HANDLE_NOTICE_POPUP_CLOSE]: (state) => ({ ...state, open: false }),
        [HANDLE_NOTICE_POPUP_DATA]: (state, { payload: popups }) => ({ ...state, popups }),
    },
    initialState,
);

export default module;
